import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressBar", "progressText", "progressStatus"]

  connect() {
    // Task controller connected and ready
  }

  updateProgress(percentage, completedCount, totalCount) {
    // Update progress bar width
    const progressBar = document.getElementById('progress-bar')
    if (progressBar) {
      progressBar.style.width = `${percentage}%`
      progressBar.setAttribute('aria-valuenow', percentage)
    }

    // Update progress text
    const progressText = document.getElementById('progress-text')
    if (progressText) {
      progressText.textContent = `${percentage}% (${completedCount}/${totalCount})`
    }
  }

  updateProgressStatus(percentage) {
    const progressStatus = document.querySelector('#task-progress .mt-3')
    if (!progressStatus) return

    let statusHtml = ''
    
    if (percentage === 100) {
      statusHtml = `
        <div class="flex items-center gap-2 text-emerald-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span class="text-sm font-medium">All deliverables completed!</span>
        </div>
      `
    } else if (percentage >= 75) {
      statusHtml = `
        <div class="flex items-center gap-2 text-blue-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
          <span class="text-sm font-medium">Great progress!</span>
        </div>
      `
    } else if (percentage >= 50) {
      statusHtml = `
        <div class="flex items-center gap-2 text-amber-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span class="text-sm font-medium">Halfway there!</span>
        </div>
      `
    } else {
      statusHtml = `
        <div class="flex items-center gap-2 text-gray-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span class="text-sm font-medium">Getting started...</span>
        </div>
      `
    }

    progressStatus.innerHTML = statusHtml
  }
}
